import { createGlobalStyle } from 'styled-components';

import '@zeiss/ods-components-react/dist/main.css';

const GlobalStyle = createGlobalStyle`

  :root {
    --header-height: 184px;
    --footer-height: 160px;
    --main-height: calc(100vh - 184px - 160px);
    --side-padding: 96px;
  }

  @media (max-width: 1919px) {
    :root {
      --side-padding: 16px;
      //--main-height: initial; // enables scroll on small devices
    }
  }

  body {
    margin: 0;
    padding: 0;
    overflow-x: hidden;

    * {
      box-sizing: border-box;
    }
  }
`;

export default GlobalStyle;
